import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Home, Booked, NotFound } from "./pages";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/booked" element={<Booked />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
